import isExists from './isExists';

export default function createSkuPattern(color, size) {
  const result = [] as string[];

  if (isExists(color) && color.length) {
    result.push(color);
  }

  if (isExists(size) && size.length) {
    result.push(size);
  }

  return result.join(' | ');
}
